import { connect } from 'react-redux'
import Settings from './Settings'
import { submit } from 'redux-form'
import { get } from 'lodash'

const stateToProps = ({ auth, form }) => ({
  user: auth.user,
  savePending: get(form, 'settingsForm.submitting', false),
})

const dispatchToProps = {
  submit,
}

export default connect(stateToProps, dispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/pages/Settings/Settings.container.js